// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Pc0C","rootMobile":"styles_rootMobile__3PX0T"};